// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCG2WoeFepDR3YdOltDoZl5L5WSAfpHtHc",
  authDomain: "ats-verifier.firebaseapp.com",
  projectId: "ats-verifier",
  storageBucket: "ats-verifier.firebasestorage.app",
  messagingSenderId: "909166935831",
  appId: "1:909166935831:web:e9e01b396683efccc2c152",
  measurementId: "G-0TVCW3KVES"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
